<template>
  <div>
    <h3 v-if="state && ![STATE_INIT, STATE_DONE].includes(state)">
      Kartenzahlung
    </h3>
    <template v-if="state === STATE_EXEC">
      <div class="align-center">
        <v-progress-circular size="50" indeterminate color="primary"/>
        <div v-if="terminalMessage">{{terminalMessage}}</div>
      </div>
    </template>
    <slot name="actions" />
    <slot name="footer" :footerInfo="additionalFooterInformation" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import axios from "axios"
import {
  STATE_DONE,
  STATE_EXEC,
  STATE_HANDLE,
  STATE_INIT,
} from "../store/payment/state-types"
import config from '@/config'
import { MinipaydTask } from '../lib/minipayd'

export default {
  name: "PaymentFragmentMinipayd",
  props: {
    state: {
      type: String,
      required: false,
      default: null,
    },
    appKind: {
      validator: (x) => ["spende.app", "kollekte.app", "spendeapp-fs"].includes(x),
      default: "spendeapp-fs",
    },
    selectedMethod: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data () {
    return {
      STATE_INIT,
      STATE_EXEC,
      STATE_DONE,
      terminalMessage: null,
      runningActionId: null,
    }
  },
  computed: {
    ...mapState("payment", ["integrationData", "memoText"]),
    ...mapState("payment", {
      paymentInput: "input",
    }),
    additionalFooterInformation () {
      return 'Dort erscheint das Wort „Spende" und der Name der Organisation als Verwendungszweck.'
    },
  },
  watch: {
    state: {
      immediate: true,
      async handler (newVal) {
        if (newVal === null) {
          this.reset()
        }

        if (this.selectedMethod.integration !== "minipayd") {
          return
        }

        if (newVal === STATE_HANDLE) {
          this.$emit("goto", STATE_EXEC)
        } else if (newVal === STATE_INIT) {
          this.$emit("goto", STATE_HANDLE)
        } else if (newVal === STATE_EXEC) {
          await this.execute()
        }
      },
    },
  },
  methods: {
    reset () {
      this.terminalMessage = null
      this.minipaydTask = new MinipaydTask()
    },
    async abort () {
      await this.minipaydTask.abort()
    },
    async execute () {
      const state = this.$store.state.payment
      const receipts = []

      try {
        const response = await axios.post(
          `${config.backend.rest}payment/payment/`,
          {
            collection_id: state.input.collection.id,
            collection_name: state.input.collection.plan.name,
            amount: state.input.amount,
            currency: state.input.currency,
          }
        )
        let backendPayment = response.data

        const finalStatus = await this.minipaydTask.exec("payment", {
          amount: state.input.amount,
          currency: state.input.currency,
        })

        receipts.push(...finalStatus.receipts)
        // FIXME Handle receipts

        try {
          backendPayment = await axios.patch(`${backendPayment.url}`, {
            state: {
              success: "completed",
              failure: "failed",
              aborted: "aborted"
            }?.[finalStatus.status] ?? "failed",
          }).then(res => res.data)
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
        }

        this.$emit("goto", "done", {
          successful: finalStatus.status === "success",
          data: {
            final_result_type: null,
            payment: backendPayment,
          }
        })
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
        this.$emit("goto", "done", {
          successful: false,
          message: `Technischer Fehler in der Datenübermittlung: ${error}`,
        })
      }
    },
  },
  async beforeUnmount () {
    await this.abort()
  }
}
</script>
